import CallTableServerUseCase from './user-cases/call-table-server-use-case';
import OrderPaidUseCase from './user-cases/order-paid-use-case';
import TriggerUserInteractionUseCase from './user-cases/trigger-user-interaction';


const IframeEventService = {
  triggerCallTableServer() {
    CallTableServerUseCase.execute();
  },

  triggerOrderPaid() {
    OrderPaidUseCase.execute();
  },

  triggerUserInteraction() {
    TriggerUserInteractionUseCase.execute();
  }
};

export default IframeEventService;
